import { Progress } from 'react-sweet-progress'
import { useEffect, useRef, useState } from 'react'
import { getLocalStorageItem, setLocalStorageItem } from '../../Helper/cookieHelper'
import { v4 as uuidv4 } from 'uuid'
import { request } from '../../Redux/Sagas/requests/api'
import { useDispatch, useSelector } from 'react-redux'
import { setNotification } from '../../Redux/Reducers/notificationHandling'
import { primary_color } from '../../Helper/uiHelper'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { setTimerChanged } from '../../Redux/Reducers/timer'
import { readBookingSession } from '../../Helper/publicPageHelper'
import CMSWidgetModal from '../CMSWidget/cmsWidgetModal'
import CMSReservation from '../CMSWidget/SidebarWidget/cmsReservation'

import moment from 'moment'
import {
  RESERVATION_DEFAULT_DURATION_SECONDS,
  RESERVATION_MAX_DURATION_SECONDS,
} from '../../Helper/reservationConstants'
function getDifferenceInSeconds(dateString2) {
  const date1 = moment()
  const date2 = moment(dateString2)

  const difference = date1.diff(date2, 'seconds')

  return difference
}

const ReservationExpire = ({
  data,
  parentData,
  widgetUUID,
  setParentData,
  pageData,
  setActivePage,
  onGoBackToHomePage,
  sidebarCollapsed = false,
}) => {
  const [timeLeft, setTimeLeft] = useState(RESERVATION_DEFAULT_DURATION_SECONDS)
  const [addTimerDisabled, setAddTimerDisabled] = useState(false)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const dispatch = useDispatch()
  const editMode = useSelector((state) => state.CMS.editMode)

  const divRef = useRef(null)
  /** Interval callbacks close over stale `current_storage_timer`; always read the live session uuid here. */
  const activeSessionUuidRef = useRef(null)
  const onGoBackToHomePageRef = useRef(onGoBackToHomePage)
  onGoBackToHomePageRef.current = onGoBackToHomePage

  let current_storage_timer = readBookingSession(parentData?.id)

  let percent = 100
  if (current_storage_timer?.duration) {
    percent = Math.round(((current_storage_timer?.duration - timeLeft) / current_storage_timer?.duration) * 100)
    percent = 100 - percent // Reverse the percentage
  }

  const sectionRef = useRef(null)

  const [modalPosition, setModalPosition] = useState()

  const handleSectionClick = () => {
    if (!editMode) return
    if (sectionRef.current) {
      const rect = sectionRef.current.getBoundingClientRect()
      setModalPosition({
        //  top: rect.top + window.scrollY - 50,
        top: rect.height + 100,

        //  left: `${rect.left + window.scrollX + rect.width / 2 - 10}px` , // Position below the parent element
        //  left: rect.left + window.scrollX, // Align left edge with parent element
        width: '60vw',
      })
    }
  }

  const onCloseModal = () => {
    let element = sectionRef?.current
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' })
    }
    setModalPosition(null)
  }

  const resetPage = () => {
    dispatch(setNotification({ type: 'error', message: 'Time is expired!' }))
    onGoBackToHomePageRef.current?.()
  }

  useEffect(() => {
    const domainId = parentData?.id
    if (!domainId) {
      return
    }

    let cancelled = false

    let storage_timer
    try {
      storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
    } catch {
      storage_timer = null
    }
    let current_storage_timer = readBookingSession(domainId)
    activeSessionUuidRef.current = current_storage_timer?.session_uuid || null

    const readTimerRow = () => {
      try {
        const raw = getLocalStorageItem('timer')
        const t = raw && JSON.parse(raw)
        return readBookingSession(domainId)
      } catch {
        return null
      }
    }

    const expireActiveReservationSession = () => {
      const fromRef = activeSessionUuidRef.current
      const row = readTimerRow()
      const uuid = fromRef || row?.session_uuid
      if (uuid) {
        request(`expire-reservation-session/${uuid}`, 'GET')
      }
    }

    let interval

    if (!storage_timer) {
      let data = {}
      const new_session_id = 'BOOKING-SESSION-' + uuidv4()
      let payload = {
        session_key: new_session_id,
        reservation_widget: widgetUUID,
        domain_id: String(domainId),
      }
      let current_row_timer = {
        session_id: new_session_id,
      }
      request('create-reservation', 'POST', payload).then((res) => {
        if (cancelled) return
        current_row_timer = {
          ...current_row_timer,
          time: new Date().toString(),
          session_uuid: res?.data?.data?.uuid,
          duration: RESERVATION_DEFAULT_DURATION_SECONDS,
        }
        data[domainId] = current_row_timer
        setLocalStorageItem('timer', JSON.stringify(data))
        activeSessionUuidRef.current = current_row_timer.session_uuid || null
        if (!current_row_timer.session_uuid) {
          return
        }

        setTimeLeft(RESERVATION_DEFAULT_DURATION_SECONDS)
        dispatch(setTimerChanged({ isTimerChanged: true }))
        setTimeout(() => {
          dispatch(setTimerChanged({ isTimerChanged: false }))
        }, 1000)
        interval = setInterval(() => {
          setTimeLeft((prevTimeLeft) => {
            if (prevTimeLeft <= 0) {
              expireActiveReservationSession()
              clearInterval(interval)
              resetPage()
              return null
            }
            return prevTimeLeft - 1
          })
        }, 1000)
      })
    }
    if (storage_timer && current_storage_timer && current_storage_timer?.duration !== 72000) {
      if (getDifferenceInSeconds(current_storage_timer?.time) <= parseInt(current_storage_timer?.duration)) {
        setTimeLeft(parseInt(current_storage_timer?.duration) - getDifferenceInSeconds(current_storage_timer?.time))
        dispatch(setTimerChanged({ isTimerChanged: true }))
        setTimeout(() => {
          dispatch(setTimerChanged({ isTimerChanged: false }))
        }, 1000)
        interval = setInterval(() => {
          setTimeLeft((prevTimeLeft) => {
            if (prevTimeLeft <= 0) {
              expireActiveReservationSession()
              clearInterval(interval)
              resetPage()
              return null
            }
            return prevTimeLeft - 1
          })
        }, 1000)
      } else {
        expireActiveReservationSession()
        let data = {
          ...storage_timer,
        }
        const new_session_id = 'BOOKING-SESSION-' + uuidv4()
        let payload = {
          session_key: new_session_id,
          reservation_widget: widgetUUID,
          domain_id: String(domainId),
        }
        let current_row_timer = {
          session_id: new_session_id,
        }
        request('create-reservation', 'POST', payload).then((res) => {
          if (cancelled) return
          current_row_timer = {
            ...current_row_timer,
            time: new Date().toString(),
            session_uuid: res?.data?.data?.uuid,
            duration: RESERVATION_DEFAULT_DURATION_SECONDS,
          }
          data[domainId] = current_row_timer
          setLocalStorageItem('timer', JSON.stringify(data))
          activeSessionUuidRef.current = current_row_timer.session_uuid || null
          if (!current_row_timer.session_uuid) {
            return
          }

          setTimeLeft(RESERVATION_DEFAULT_DURATION_SECONDS)
          dispatch(setTimerChanged({ isTimerChanged: true }))
          setTimeout(() => {
            dispatch(setTimerChanged({ isTimerChanged: false }))
          }, 1000)
          interval = setInterval(() => {
            setTimeLeft((prevTimeLeft) => {
              if (prevTimeLeft <= 0) {
                expireActiveReservationSession()
                clearInterval(interval)
                resetPage()
                return null
              }
              return prevTimeLeft - 1
            })
          }, 1000)
        })
      }
    } else if (storage_timer && (!current_storage_timer || current_storage_timer?.duration === 72000)) {
      let data = {
        ...storage_timer,
      }
      const new_session_id = 'BOOKING-SESSION-' + uuidv4()
      let payload = {
        session_key: new_session_id,
        reservation_widget: widgetUUID,
        domain_id: String(domainId),
      }
      let current_row_timer = {
        session_id: new_session_id,
      }
      request('create-reservation', 'POST', payload).then((res) => {
        if (cancelled) return
        current_row_timer = {
          ...current_row_timer,
          time: new Date().toString(),
          session_uuid: res?.data?.data?.uuid,
          duration: RESERVATION_DEFAULT_DURATION_SECONDS,
        }
        data[domainId] = current_row_timer
        setLocalStorageItem('timer', JSON.stringify(data))
        activeSessionUuidRef.current = current_row_timer.session_uuid || null
        if (!current_row_timer.session_uuid) {
          return
        }
        setTimeLeft(RESERVATION_DEFAULT_DURATION_SECONDS)
        dispatch(setTimerChanged({ isTimerChanged: true }))
        setTimeout(() => {
          dispatch(setTimerChanged({ isTimerChanged: false }))
        }, 1000)
        interval = setInterval(() => {
          setTimeLeft((prevTimeLeft) => {
            if (prevTimeLeft <= 0) {
              expireActiveReservationSession()
              clearInterval(interval)
              resetPage()
              return null
            }
            return prevTimeLeft - 1
          })
        }, 1000)
      })
    }

    return () => {
      cancelled = true
      if (interval) clearInterval(interval)
    }
  }, [parentData?.id, widgetUUID, location.search, dispatch])

  const onAddMoreTime = () => {
    let storage_timer = getLocalStorageItem('timer') && JSON.parse(getLocalStorageItem('timer'))
    let current_storage_timer = readBookingSession(parentData?.id)
    const prevDurationBeforeAdd = parseInt(current_storage_timer?.duration, 10) || 0
    if (prevDurationBeforeAdd >= RESERVATION_MAX_DURATION_SECONDS) {
      return
    }
    setAddTimerDisabled(true)
    dispatch(setTimerChanged({ isTimerChanged: true }))
    let payload = {
      timer_uuid: current_storage_timer?.session_uuid,
    }
    request(`reservation/add-time/${current_storage_timer?.session_uuid}`, 'POST', payload)
      .then((res) => {
        if (res.status !== 200 && res.status !== 202) {
          dispatch(setNotification({ type: 'error', message: res?.data?.message }))
          return
        }
        let data = {
          ...storage_timer,
        }
        const prevDuration = parseInt(current_storage_timer?.duration, 10) || 0
        const nextDuration = Math.min(prevDuration + 120, RESERVATION_MAX_DURATION_SECONDS)
        const delta = nextDuration - prevDuration
        let current_row_timer = {
          ...current_storage_timer,
          duration: nextDuration,
        }
        data[parentData?.id] = current_row_timer
        setLocalStorageItem('timer', JSON.stringify(data))
        setAddTimerDisabled(false)
        setTimeLeft((prevTimeLeft) => {
          return prevTimeLeft + delta
        })
        dispatch(setTimerChanged({ isTimerChanged: false }))
      })
      .catch((e) => {
        console.error('error', e)
        setAddTimerDisabled(false)
        dispatch(setTimerChanged({ isTimerChanged: false }))
      })
  }

  let minutes = Math.floor(timeLeft / 60)
  let seconds = timeLeft % 60

  if (minutes < 10) minutes = '0' + minutes
  if (seconds < 10) seconds = '0' + seconds

  const themeColor = minutes === '01' ? '#ffde55' : minutes === '00' ? '#f87171' : primary_color

  let heading = data?.heading || 'Reservation expires in'

  if (data?.heading && data?.heading?.toLowerCase().includes(' in')) {
    const indexOfIn = data?.heading?.toLowerCase().indexOf('in')
    let firstPart = data?.heading?.slice(0, indexOfIn).trim()
    let secondPart = data?.heading?.slice(indexOfIn).trim()

    heading = (
      <>
        <span style={{ fontWeight: 800 }}>{firstPart}</span>
        <span style={{ fontWeight: 500 }}> {secondPart}</span>
      </>
    )
  }

  useEffect(() => {
    if (!divRef.current) return
    const pElements = divRef.current.querySelectorAll('p')
    pElements.forEach((p) => {
      p.style.color = themeColor
    })
  }, [themeColor, sidebarCollapsed])

  /* Do not use CMS button_text here — it often says "Reservation" and confuses users; keep copy explicit. */
  const addTimeLabel = sidebarCollapsed ? '+2 min' : '+ Add 2 min'

  return (
    <div
      className={`reservation-widget reservation-expire ${modalPosition && 'active-cms-edit'}`}
      onClick={handleSectionClick}
      ref={sectionRef}
      style={
        sidebarCollapsed
          ? { padding: '0.35rem 0', borderBlock: 'none', textAlign: 'center' }
          : { padding: '2.5rem 0', borderBlock: '1px solid lightgrey' }
      }>
      {!sidebarCollapsed && (
        <>
          <div
            className='reservation-expire__heading primary-color body1'
            dangerouslySetInnerHTML={{ __html: data?.heading }}
            style={{ color: themeColor }}></div>
          <div className='reservation-expire__timer' style={{ fontWeight: '700' }}>
            <span className='reservation-expire__timer-main' style={{ color: themeColor, fontSize: '5rem', fontWeight: '900' }}>
              {minutes !== '00' ? minutes : seconds}
            </span>{' '}
            {minutes !== '00' ? (
              <span className='reservation-expire__timer-sub' style={{ fontSize: '2rem', color: 'grey' }}>
                {seconds}
              </span>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
      <span
        className='reservation-expire__timer-compact'
        style={{
          display: sidebarCollapsed ? 'block' : 'none',
          color: themeColor,
          fontWeight: 800,
        }}>
        {minutes}:{seconds}
      </span>

      {!sidebarCollapsed && (
        <>
          <div
            className='reservation-expire__progress align-center hide-progress-symbole mt-n3'
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Progress
              percent={percent}
              theme={{
                active: {
                  symbol: ' ',
                  trailColor: '#eaeaea',
                  color: themeColor,
                },
                success: {
                  symbol: 100 + '%',
                  trailColor: '#eaeaea',
                  color: themeColor,
                },
              }}
              width='100%'
            />
          </div>
          <div className='reservation-expire__unit-label h5 mt-2 mb-5' style={{ color: themeColor, fontWeight: '700' }}>
            {minutes !== '00' ? 'Minutes' : 'Seconds'}
          </div>
          <div
            className='reservation-expire__sub subtitle1'
            ref={divRef}
            style={{ color: themeColor }}
            dangerouslySetInnerHTML={{ __html: data?.sub_heading }}></div>
        </>
      )}
      <button
        type='button'
        disabled={
          addTimerDisabled ||
          (parseInt(current_storage_timer?.duration, 10) || 0) >= RESERVATION_MAX_DURATION_SECONDS
        }
        className='reservation-expire__add-btn btn btn-primary rounded-pill font-weight-bold mt-2  w-100 subtitle1'
        style={{ background: themeColor }}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onAddMoreTime()
        }}>
        {addTimeLabel}
      </button>
      {modalPosition && (
        <CMSWidgetModal sx={{ ...modalPosition }} toggleModal={() => onCloseModal()}>
          <CMSReservation
            data={data}
            toggleModal={() => {
              onCloseModal()
            }}
            widget_uuid={widgetUUID}
          />
        </CMSWidgetModal>
      )}
    </div>
  )
}

export default ReservationExpire
